import { Mutation } from 'vuex'
import { UserState } from '../types'

const setUserDisabledTextNotifications: Mutation<UserState> = (
  state,
  payload: boolean
) => {
  state.disableTextNotifications = payload
}

export default setUserDisabledTextNotifications
